import GlobalInfoTooltip from './global-info-tooltip';

export default GlobalInfoTooltip;